import { createEnumMap } from 'Commons/helpers/utils/Formatter';

const HEADER_VARIANT = createEnumMap(['Plain', 'With_Content']);

export { HEADER_VARIANT };
